// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickTooltip_tooltipWrap__wf4VC {
  z-index: var(--tooltipIndex);
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b {
  animation-duration: 0.3s;
  animation-delay: 0.2s;
  background: var(--lightwarn);
  color: var(--darkgray);
  padding: 0.5em;
  font-size: 0.75em;
  border-radius: 0.25em;
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.5));
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b.ClickTooltip_vertical__gEFJE {
  margin: 0.75em 0;
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b.ClickTooltip_horizontal__EkXJG {
  margin: 0 0.75em;
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b .ClickTooltip_tooltipArrow__kz-sz {
  --size: 5px;
  --position: calc(-1 * var(--size));
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border: var(--size) solid transparent;
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b .ClickTooltip_tooltipArrow__kz-sz.ClickTooltip_top__c8eWX {
  bottom: var(--position);
  border-top-color: var(--lightwarn);
  border-bottom-width: 0;
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b .ClickTooltip_tooltipArrow__kz-sz.ClickTooltip_top__c8eWX::before {
  border-top-color: var(--white);
  border-bottom-width: 0;
  margin-left: var(--position);
  margin-top: var(--position);
  transform: translateY(2px);
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b .ClickTooltip_tooltipArrow__kz-sz.ClickTooltip_bottom__\\+gt2k {
  top: var(--position);
  border-bottom-color: var(--lightwarn);
  border-top-width: 0;
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b .ClickTooltip_tooltipArrow__kz-sz.ClickTooltip_left__7ueFS {
  right: var(--position);
  border-left-color: var(--lightwarn);
  border-right-width: 0;
}
.ClickTooltip_tooltipWrap__wf4VC .ClickTooltip_tooltipContainer__Ywc6b .ClickTooltip_tooltipArrow__kz-sz.ClickTooltip_right__zeoSO {
  left: var(--position);
  border-right-color: var(--lightwarn);
  border-left-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ClickTooltip/ClickTooltip.module.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;AACF;AAAE;EACE,wBAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,mDAAA;AAEJ;AADI;EACE,gBAAA;AAGN;AADI;EACE,gBAAA;AAGN;AADI;EACE,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;AAGN;AAFM;EACE,uBAAA;EACA,kCAAA;EACA,sBAAA;AAIR;AAHQ;EACE,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;AAKV;AAFM;EACE,oBAAA;EACA,qCAAA;EACA,mBAAA;AAIR;AAFM;EACE,sBAAA;EACA,mCAAA;EACA,qBAAA;AAIR;AAFM;EACE,qBAAA;EACA,oCAAA;EACA,oBAAA;AAIR","sourcesContent":[".tooltipWrap {\n  z-index: var(--tooltipIndex);\n  .tooltipContainer {\n    animation-duration: 0.3s;\n    animation-delay: 0.2s;\n    background: var(--lightwarn);\n    color: var(--darkgray);\n    padding: 0.5em;\n    font-size: 0.75em;\n    border-radius: 0.25em;\n    filter: drop-shadow(2px 2px 2px rgba(black, 0.5));\n    &.vertical {\n      margin: 0.75em 0;\n    }\n    &.horizontal {\n      margin: 0 0.75em;\n    }\n    .tooltipArrow {\n      --size: 5px;\n      --position: calc(-1 * var(--size));\n      position: absolute;\n      display: block;\n      width: 0;\n      height: 0;\n      border: var(--size) solid transparent;\n      &.top {\n        bottom: var(--position);\n        border-top-color: var(--lightwarn);\n        border-bottom-width: 0;\n        &::before {\n          border-top-color: var(--white);\n          border-bottom-width: 0;\n          margin-left: var(--position);\n          margin-top: var(--position);\n          transform: translateY(2px);\n        }\n      }\n      &.bottom {\n        top: var(--position);\n        border-bottom-color: var(--lightwarn);\n        border-top-width: 0;\n      }\n      &.left {\n        right: var(--position);\n        border-left-color: var(--lightwarn);\n        border-right-width: 0;\n      }\n      &.right {\n        left: var(--position);\n        border-right-color: var(--lightwarn);\n        border-left-width: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipWrap": `ClickTooltip_tooltipWrap__wf4VC`,
	"tooltipContainer": `ClickTooltip_tooltipContainer__Ywc6b`,
	"vertical": `ClickTooltip_vertical__gEFJE`,
	"horizontal": `ClickTooltip_horizontal__EkXJG`,
	"tooltipArrow": `ClickTooltip_tooltipArrow__kz-sz`,
	"top": `ClickTooltip_top__c8eWX`,
	"bottom": `ClickTooltip_bottom__+gt2k`,
	"left": `ClickTooltip_left__7ueFS`,
	"right": `ClickTooltip_right__zeoSO`
};
export default ___CSS_LOADER_EXPORT___;
